import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "CodeWithSwiz: Privacy-focused embeds for YouTube, Twitter, et al",
  "description": "A new old experiment 👉 regular livecoding. It's like a podcast with video, show notes, regular cadence, and we both learn something new.",
  "published": "2020-08-27T00:00:00.000Z",
  "categories": "CodeWithSwiz, Technical, Markdown, Livecoding",
  "hero": "./img/screenshot-1598541642394.png"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Friend, here's a new old experiment 👉 regular livecoding. It's like a podcast with video, show notes, regular cadence, and we both learn something new.`}</p>
    <p>{`For me it's a regular timebox – `}<strong parentName="p">{`Wednesdays 6:30pm Pacific and Sundays 2pm Pacific`}</strong>{` – to play with new technology, explore ideas, work on open source, and `}<em parentName="p">{`hack`}</em>{`.`}</p>
    <p>{`For you it's a chance to hear about new libraries and technologies, peek behind the curtain, ask any and all questions you'd like, and with luck see cool things get built.`}</p>
    <p>{`Show notes work like a short recap.`}</p>
    <hr></hr>
    <lite-youtube {...{
      "videoid": "1TABvFT1X7Q",
      "videostartat": "0"
    }}></lite-youtube>
    <p><em parentName="p">{`PS: you can `}<a parentName="em" {...{
          "href": "https://swizec.com/blog/codewithswiz-privacy-focused-embeds-for-youtube-twitter-et-al"
        }}>{`read and share this online`}</a></em></p>
    <p>{`When websites embed 3rd party content like YouTube, Twitter, Facebook, et all, those embeds come with a bunch of cruft. Shitload of JavaScript, heavy code in iframes, and tracking scripts.`}</p>
    <p>{`You don't want that.`}</p>
    <p>{`Privacy is important and so is performance. A blank page with a single YouTube embed makes 18 requests and loads 2.2 megs of data.`}</p>
    <p><figure parentName="p" {...{
        "className": "gatsby-resp-image-figure",
        "style": {
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
    `}<span parentName="figure" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "890px"
          }
        }}>{`
      `}<a parentName="span" {...{
            "className": "gatsby-resp-image-link",
            "href": "/static/d17602958c98a0ece1d9b7e6e5276cd4/0c3d0/YouTube-embed-performance-hitfgfj5e.png",
            "style": {
              "display": "block"
            },
            "target": "_blank",
            "rel": "noopener"
          }}>{`
    `}<span parentName="a" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "108.5201793721973%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'434\\'%20viewBox=\\'0%200%20400%20434\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M0%2010v9h401V0H0v10m1%2023C0%2048%201%2071%202%2070h2l1-3%201-5h10v5l1%206V62h10v11l1-5%201-5h10v5l1%205V62h10v5l1%206V62h10v5l1%206v-6l1-5h10v5c0%203%200%205%201%204%200-2%206-3%208-1l9%203%2013%201%2014%203%2011%202h5l1%202-4%202-4%203-1%201c-2%200-7%204-6%204l4%203c4%202%204%202%202%202l-4%201c0%201-5%202-12%202-2%200-3%201-3%204-1%203-6%206-10%206h-3l-4%201-5%201-20%202-21%202c-12%203-41%203-42%201s-1%208-1%2052v34l32-1a10362%2010362%200%2000226-2c2-1%202-2%200-2h-2v-53H95v-5h45l46-1%201-36c-1-48-1-51%203-51l2-1-2-1c-2%201-3%200-2-5l2-4%201-1%201-1%201%204c0%203%200%203%201%201l1-1%201%202v-3c-1-1-1-1%201-1%201%200%202%201%202%203l1%202v-5l1%201h4l4-1c3%200%203%200%203%203l1%202v-2l14-1h14l-1-4c0-3%203-7%206-7s6%204%206%207v4h19l22%201%201%201c1-3%2020-3%2021%200s2%200%202-10V23H1v10\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/d17602958c98a0ece1d9b7e6e5276cd4/ca0a1/YouTube-embed-performance-hitfgfj5e.webp 223w", "/static/d17602958c98a0ece1d9b7e6e5276cd4/75680/YouTube-embed-performance-hitfgfj5e.webp 445w", "/static/d17602958c98a0ece1d9b7e6e5276cd4/8d1ba/YouTube-embed-performance-hitfgfj5e.webp 890w", "/static/d17602958c98a0ece1d9b7e6e5276cd4/3838e/YouTube-embed-performance-hitfgfj5e.webp 1335w", "/static/d17602958c98a0ece1d9b7e6e5276cd4/1a117/YouTube-embed-performance-hitfgfj5e.webp 1414w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/d17602958c98a0ece1d9b7e6e5276cd4/e92b6/YouTube-embed-performance-hitfgfj5e.png 223w", "/static/d17602958c98a0ece1d9b7e6e5276cd4/e66bf/YouTube-embed-performance-hitfgfj5e.png 445w", "/static/d17602958c98a0ece1d9b7e6e5276cd4/4ef49/YouTube-embed-performance-hitfgfj5e.png 890w", "/static/d17602958c98a0ece1d9b7e6e5276cd4/4e814/YouTube-embed-performance-hitfgfj5e.png 1335w", "/static/d17602958c98a0ece1d9b7e6e5276cd4/0c3d0/YouTube-embed-performance-hitfgfj5e.png 1414w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/d17602958c98a0ece1d9b7e6e5276cd4/4ef49/YouTube-embed-performance-hitfgfj5e.png",
                "alt": "YouTube embed performance hit",
                "title": "YouTube embed performance hit",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
          "className": "gatsby-resp-image-figcaption"
        }}>{`YouTube embed performance hit`}</figcaption>{`
  `}</figure></p>
    <p>{`5 cookies 😳`}</p>
    <p><figure parentName="p" {...{
        "className": "gatsby-resp-image-figure",
        "style": {
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
    `}<span parentName="figure" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "890px"
          }
        }}>{`
      `}<a parentName="span" {...{
            "className": "gatsby-resp-image-link",
            "href": "/static/9fa8ac936166cfc82ddee7328c46ef9d/b88bf/cookies-from-a-single-YT-embedi59i30.png",
            "style": {
              "display": "block"
            },
            "target": "_blank",
            "rel": "noopener"
          }}>{`
    `}<span parentName="a" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "18.385650224215244%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'74\\'%20viewBox=\\'0%200%20400%2074\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M1%2038v37l1-31V13h199a19673%2019673%200%2000196-1c-3%200-3%200-3-4%200-5%200-5%203-5L201%202H1v36M2%208v4h287V3H2v5m288%200v4h103V3H290v5m-133%209l-1%202%207%201c5%200%206-1%206-2h4c0%202%201%202%2012%202l24-1a511%20511%200%200047%200v2l1-2c1-3%201-4-1-3h-6c-1-2-4-1-3%201h-1c-3-2-10-2-12-1h-12c-6-1-6-1-6%201l-1%201-1-1-1-2-2%201h-11c-3-1-7-1-7%201l-1%201v-1c1-2%200-3-3-1h-12l-1%202c-1%201-1%200-2-1%200-2-16-3-17%200m-33%208l-1%202c0%201%202%202%2015%202%2015%200%2018-1%2015-3-1-2-19-2-21-1h-8m0%2011l-1%201%2010%201%209-1h1c2%202%2011%202%2012%200h2v-3l-2%201h-6l-2%202v-1c1-2%201-2-1-2-1%200-2%200-1%202h-1c-1-1-17-2-17%200l-1-1c0-2-2-1-2%201m10%2018c0%202-2%203-2%201l-2-2c-5%200-7%201-7%203l8%201a576%20576%200%200129-1c0-2-4-3-5-2h-5l-5-1h-7c-2-2-3-1-4%201\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/9fa8ac936166cfc82ddee7328c46ef9d/ca0a1/cookies-from-a-single-YT-embedi59i30.webp 223w", "/static/9fa8ac936166cfc82ddee7328c46ef9d/75680/cookies-from-a-single-YT-embedi59i30.webp 445w", "/static/9fa8ac936166cfc82ddee7328c46ef9d/8d1ba/cookies-from-a-single-YT-embedi59i30.webp 890w", "/static/9fa8ac936166cfc82ddee7328c46ef9d/3838e/cookies-from-a-single-YT-embedi59i30.webp 1335w", "/static/9fa8ac936166cfc82ddee7328c46ef9d/53a04/cookies-from-a-single-YT-embedi59i30.webp 1702w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/9fa8ac936166cfc82ddee7328c46ef9d/e92b6/cookies-from-a-single-YT-embedi59i30.png 223w", "/static/9fa8ac936166cfc82ddee7328c46ef9d/e66bf/cookies-from-a-single-YT-embedi59i30.png 445w", "/static/9fa8ac936166cfc82ddee7328c46ef9d/4ef49/cookies-from-a-single-YT-embedi59i30.png 890w", "/static/9fa8ac936166cfc82ddee7328c46ef9d/4e814/cookies-from-a-single-YT-embedi59i30.png 1335w", "/static/9fa8ac936166cfc82ddee7328c46ef9d/b88bf/cookies-from-a-single-YT-embedi59i30.png 1702w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/9fa8ac936166cfc82ddee7328c46ef9d/4ef49/cookies-from-a-single-YT-embedi59i30.png",
                "alt": "cookies from a single YT embed",
                "title": "cookies from a single YT embed",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
          "className": "gatsby-resp-image-figcaption"
        }}>{`cookies from a single YT embed`}</figcaption>{`
  `}</figure></p>
    <p>{`What if instead of embedding with an iframe, you showed a thumbnail first? Load dynamic content when user interacts and shows intent. Says `}<em parentName="p">{`"Yes, I wanna see this"`}</em></p>
    <p>{`The way `}<a parentName="p" {...{
        "href": "https://techletter.app"
      }}>{`TechLetter.App`}</a>{` works for emails. But without taking you to a new page on click.`}</p>
    <p>{`Here's the plan:`}</p>
    <ul>
      <li parentName="ul">{`take existing AWS Lambda screenshot machinery`}</li>
      <li parentName="ul">{`make a Gatsby plugin that turns embeds into thumbnails`}</li>
      <li parentName="ul">{`inject vanilla JavaScript to turn into proper embeds`}</li>
    </ul>
    <p>{`Started with a dirty proof of concept. It worked 🤘`}</p>
    <lite-youtube {...{
      "videoid": "2JztRv9Q6Q8",
      "videostartat": "0"
    }}></lite-youtube>
    <p>{`Time to build a plugin! That did not go well.`}</p>
    <p>{`First, we ran into issues with plugin building for Gatsby. You have to keep clearing cache, rebuilding the whole site, and waiting a lot.`}</p>
    <p>{`When your computer is busy streaming, you're waiting `}<em parentName="p">{`a lot`}</em>{`.`}</p>
    <p>{`Should've written tests instead 😅`}</p>
    <p>{`But fear not, we got the thumbnail part working. First for YouTube, later we can expand. It's a remark plugin like this:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`export default async function (
    { cache, markdownAST },
    pluginOptions: PluginOptions
) {
    const transformations = [];

    visit(markdownAST, "link", (linkNode) => {
        const url = linkNode.url as string;

        if (url.match(/^http(s)?:\\/\\/(www\\.)?(youtube\\.com|youtu\\.be)/)) {
            transformations.push(async () => embed(linkNode, "youtube"));
        }
    });

    await Promise.all(transformations.map((t) => t()));

    return markdownAST;
}
`}</code></pre>
    <p>{`Visits all `}<inlineCode parentName="p">{`link`}</inlineCode>{` nodes in your document, checks if they're YouTube, and turns them into a thumbnail `}<inlineCode parentName="p">{`embed`}</inlineCode>{`.`}</p>
    <p>{`Transformation to an embed looks like this:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`async function embed(linkNode, embedType: "youtube") {
  const originalUrl = linkNode.url;
  const thumbnailUrl = await getThumbnail(originalUrl);

  if (thumbnailUrl) {
    linkNode.type = "image";
    linkNode.url = thumbnailUrl;
    linkNode.title = "A youtube video";
    linkNode.alt = "A youtube video";
    linkNode.children = null;
    linkNode.data = {
      ...linkNode.data,
    };

    linkNode.data.hProperties = {
      ...linkNode.data.hProperties,
      "data-embed-url": getYouTubeIFrameSrc(originalUrl),
      "data-embed-type": embedType,
    };
  }

  return linkNode;
}
`}</code></pre>
    <p><inlineCode parentName="p">{`linkNode.data.hProperties`}</inlineCode>{` is how you can add HTML properties to your Markdown nodes. Didn't know that before, stole it from another plugin on stream ✌️`}</p>
    <p>{`The `}<inlineCode parentName="p">{`getThumbnail`}</inlineCode>{` method talks to my AWS Lambda running Chrome Puppeteer. Takes a screenshot of the YouTube video, saves it to S3, and returns the URL.`}</p>
    <p>{`You can read about that in `}<a parentName="p" {...{
        "href": "https://serverlesshandbook.dev/serverless-chrome-puppeteer"
      }}>{`Serverless Handbook: Chrome puppeteer chapter`}</a>{`.`}</p>
    <p>{`We're using `}<inlineCode parentName="p">{`data-embed-url`}</inlineCode>{` and `}<inlineCode parentName="p">{`data-embed-type`}</inlineCode>{` to tell the injected JavaScript what to do. Meant to turn this thumbnail into an iframe when you click.`}</p>
    <p>{`Gatsby lets us inject JavaScript on page load. Export an `}<inlineCode parentName="p">{`onRouteUpdate`}</inlineCode>{` method from `}<inlineCode parentName="p">{`gatsby-browser.js`}</inlineCode>{`.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`exports.onRouteUpdate = () => {
  if (document.querySelector("[data-embed-url]")) {
    addJS(\`
for (let embed of document.querySelectorAll('[data-embed-url]')) {
    embed.addEventListener('click', (event) => {
        const embed = event.currentTarget;

        const type = embed.dataset.embedType;
        const url = embed.dataset.embedUrl;
        const dimensions = embed.getBoundingClientRect();

        if (type === 'youtube') {
            const el = document.createElement('p');

            el.innerHTML = '<iframe title="Youtube embed" width="'+dimensions.width+'px" height="'+dimensions.height+'px" src="'+url+'" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen=""></iframe>';

            embed.replaceWith(el);
        }
    })
}
        \`);
  }
};
`}</code></pre>
    <p>{`Yeah writing code in a string sucks. You don't have React either. And I gotta say vanilla JavaScript has improved lots in the past few years.`}</p>
    <p>{`This code looks for all elements with a `}<inlineCode parentName="p">{`data-embed-url`}</inlineCode>{` property and adds a `}<inlineCode parentName="p">{`click`}</inlineCode>{` listener. When you click, it replaces the element with an HTML string.`}</p>
    <p>{`Adding it to the page is a matter of injecting a new `}<inlineCode parentName="p">{`<script>`}</inlineCode>{` tag into document head.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`function addJS(jsCode) {
  const s = document.createElement(\`script\`);

  s.type = \`text/javascript\`;
  s.innerText = jsCode;
  document.getElementsByTagName(\`head\`)[0].appendChild(s);
}
`}</code></pre>
    <p>{`Where I'm stuck now is with Gatsby shadowing and moving all this code to the existing `}<a parentName="p" {...{
        "href": "https://github.com/MichaelDeBoey/gatsby-remark-embedder"
      }}>{`gatsby-remark-embedder`}</a>{` plugin. Got the thumbnails to work, but not the in-browser JavaScript.`}</p>
    <p><a parentName="p" {...{
        "href": "https://www.gatsbyjs.com/docs/how-shadowing-works/"
      }}>{`Gatsby shadowing`}</a>{` says you can put `}<inlineCode parentName="p">{`gatsby-browser.js`}</inlineCode>{` in your plugin and Gatsby will run that code. But it's not working for me 🤨`}</p>
    <p>{`Next time!`}</p>
    <p>{`Cheers,
~Swizec`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      